import { inject } from '@angular/core';
import { CanActivateChildFn, GuardResult, Router } from '@angular/router';
import { SessionStoreRepository } from '../../repositories/session.repository';
import { ConsentStoreRepository } from '../../repositories/consent.repository';
import { Observable, map, catchError, of } from 'rxjs';

export const consentGuard: CanActivateChildFn = (): Observable<GuardResult> | GuardResult => {
    const router = inject(Router);
    const isPatient = inject(SessionStoreRepository).isPatient;
    const consentRepository = inject(ConsentStoreRepository);

    if (isPatient && consentRepository.hasConsent === null) {
        return consentRepository.loadHasConsent$().pipe(
            map(() => {
                return (isPatient && consentRepository.hasConsent) || router.createUrlTree(['/authenticated']);
            }),
            catchError(() => {
                return of(router.createUrlTree(['/authenticated']));
            })
        );
    }

    return (!isPatient || (isPatient && consentRepository.hasConsent)) || router.createUrlTree(['/authenticated']);
};

export const consentRequiredGuard: CanActivateChildFn = (): Observable<GuardResult> | GuardResult => {
    const router = inject(Router);
    const consentRepository = inject(ConsentStoreRepository);

    if (consentRepository.hasConsent === null) {
        return consentRepository.loadHasConsent$().pipe(
            map((hasConsent: boolean) => {
                return !hasConsent || router.createUrlTree(['/authenticated']);
            }),
            catchError(() => {
                return of(router.createUrlTree(['/authenticated']));
            })
        );
    }

    return !consentRepository.hasConsent || router.createUrlTree(['/authenticated']);
};